<template>
  <div>
    <div class="row mt-5 mr-2 ml-2 justify-content-md-center">
      <div class="col-lg-5">
        <div class="row mb-3 justify-content-md-center">
          <div class="col-xl-8 mb-3">
            <section class="card card-featured card-featured-primary mb-4 mt-4">
              <header class="card-header">
                <h2 class="card-title">Account Setup</h2>
              </header>
              <div class="card-body">
                <!-- Loading Progress Indicator -->
                <div v-if="isSaving" class="loading-progress mb-4">
                  <div class="progress-indicator">
                    <div class="step" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
                      <div class="step-icon">
                        <i v-if="currentStep > 1" class="fas fa-check"></i>
                        <span v-else>1</span>
                      </div>
                      <div class="step-label">Creating User</div>
                    </div>
                    <div class="step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
                      <div class="step-icon">
                        <i v-if="currentStep > 2" class="fas fa-check"></i>
                        <span v-else>2</span>
                      </div>
                      <div class="step-label">Attaching to Patient</div>
                    </div>
                    <div class="step" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
                      <div class="step-icon">
                        <i v-if="currentStep > 3" class="fas fa-check"></i>
                        <span v-else>3</span>
                      </div>
                      <div class="step-label">Loading Profile</div>
                    </div>
                    <div class="step" :class="{ active: currentStep >= 4, completed: currentStep > 4 }">
                      <div class="step-icon">
                        <i v-if="currentStep > 4" class="fas fa-check"></i>
                        <span v-else>4</span>
                      </div>
                      <div class="step-label">Setting Up Access</div>
                    </div>
                  </div>
                  <div class="current-step-message">
                    {{ currentStepMessage }}
                  </div>
                </div>

                <form @submit.prevent="submitForm">
                  <div class="form-group">
                    <label for="exampleInputEmail1">Email</label>
                    <input
                      v-model="form.email"
                      type="email"
                      class="form-control form-control"
                      placeholder="Email"
                      required
                      autocomplete="username"
                      id="em"
                      tabindex="0"
                    />
                  </div>
                  <div class="form-group mb-4">
                    <label>Password</label>
                    <div class="input-group mb-3">
                      <span class="input-group-prepend">
                        <span
                          class="input-group-text"
                          @click="showPassword = !showPassword"
                        >
                          <i
                            :class="{
                              'far fa-eye': !showPassword,
                              'far fa-eye-slash': showPassword
                            }"
                          ></i>
                        </span>
                      </span>
                      <input
                        v-model="form.password"
                        @input="checkPassword"
                        :type="showPassword ? 'text' : 'password'"
                        class="form-control"
                        placeholder="Password"
                        maxlength="50"
                        minlength="8"
                        required
                        autocomplete="new-password"
                      />
                    </div>
                    <ul>
                      <li
                        v-bind:class="{ is_valid: contains_eight_characters }"
                      >
                        At least 8 characters
                      </li>
                      <li v-bind:class="{ is_valid: contains_number }">
                        Contains Number
                      </li>
                      <li v-bind:class="{ is_valid: contains_uppercase }">
                        Contains Uppercase
                      </li>
                      <li
                        v-bind:class="{ is_valid: contains_special_character }"
                      >
                        Contains Special Character
                      </li>
                    </ul>
                  </div>
                  <div class="form-group mb-4">
                    <label>Confirm Password</label>
                    <div class="input-group mb-3">
                      <span class="input-group-prepend">
                        <span
                          class="input-group-text"
                          @click="showConfirmPassword = !showConfirmPassword"
                        >
                          <i
                            :class="{
                              'far fa-eye': !showConfirmPassword,
                              'far fa-eye-slash': showConfirmPassword
                            }"
                          ></i>
                        </span>
                      </span>
                      <input
                        v-model="form.confirmPassword"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        class="form-control"
                        placeholder="Confirm Password"
                        maxlength="50"
                        minlength="8"
                        required
                        autocomplete="new-password"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <btn-saving :is-saving="isSaving" />
                  </div>
                  <div class="form-group">
                    <h5>
                      Existing account?
                      <a href="javascript:void(0)" @click="gotoLogin"
                        >Login instead</a
                      >
                    </h5>
                  </div>
                </form>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BtnSaving from '../../components/button-saving.vue'
import api from '../../api/http-common.js'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    BtnSaving
  },
  props: {
    linkInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isSaving: false,
      currentStep: 0,
      currentStepMessage: '',
      form: {
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        MobilePhone: ''
      },
      showPassword: false,
      showConfirmPassword: false,
      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      valid_password: false,
      patientInfo: null,
      task: undefined
    }
  },
  computed: {
    ...mapGetters(['getTaskIsAccessOnly', 'getTaskIsAccessOnlyRoute']),
    key() {
      return this.$route.query.key
    }
  },
  methods: {
    ...mapActions([
      'setIsLoading',
      'setProfileAuthInfo',
      'setTaskCurrentTaskType',
      'setProfilePatientAssociated',
      'setProfileCurrentPatient',
      'setTaskOfficeName',
      'setTaskCode',
      'setTaskIsAccessOnly',
      'setBillingStatementTask',
      'setFacilityInfo'
    ]),
    checkPassword() {
      this.password_length = this.form.password.length
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/

      if (this.password_length > 8) {
        this.contains_eight_characters = true
      } else {
        this.contains_eight_characters = false
      }

      this.contains_number = /\d/.test(this.form.password)
      this.contains_uppercase = /[A-Z]/.test(this.form.password)
      this.contains_special_character = format.test(this.form.password)

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true
      } else {
        this.valid_password = false
      }
    },
    updateStep(step, message) {
      this.currentStep = step
      this.currentStepMessage = message
    },
    async submitForm() {
      if (!this.validatePassword()) return
      if (!this.validatePasswordConfirmation()) return

      this.isSaving = true
      this.updateStep(1, 'Creating user account...')

      try {
        const insertUserRes = await this.createUserAccount()
        if (!insertUserRes) return

        await this.validateUserCredentials()

        if (this.linkInfo) {
          const success = await this.attachUserToPatient(insertUserRes.data.id)
          if (!success) return
        }

        await this.loadPatientProfile(insertUserRes.data.id)
      } catch (error) {
        this.handleAccountCreationError(error)
      }
    },
    // Validation methods
    validatePassword() {
      if (this.valid_password) return true

      const errorMessages = {
        contains_eight_characters: 'Password should have a minimum length of 8 characters.',
        contains_number: 'Password should contain at least 1 number.',
        contains_uppercase: 'Password should contain at least 1 upper case.',
        contains_special_character: 'Password should contain at least 1 special character.'
      }

      const error = Object.entries(errorMessages).find(
        ([key]) => !this[key]
      )?.[1] || 'Password validation failed.'

      this.showPasswordError(error)
      return false
    },
    validatePasswordConfirmation() {
      if (this.form.password === this.form.confirmPassword) return true

      this.showPasswordError('Confirm password doest not match.')
      return false
    },
    showPasswordError(message) {
      this.$swal({
        position: 'top',
        title: 'Password error',
        text: message,
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 2000,
        icon: 'error'
      })
    },
    // Account creation methods
    async createUserAccount() {
      const insertUserRes = await api.auth.request.insertUser({
        email: this.form.email,
        pwd: this.form.password,
        key: this.key,
        facilityPatient: {
          facilityKey: this.linkInfo.facilityKey,
          patientKey: this.linkInfo.patientKey
        }
      })

      if (!insertUserRes.data.value) {
        this.showError('Create account error', insertUserRes.data.reason, 2000)
        this.resetSavingState()
        return null
      }

      return insertUserRes
    },
    async validateUserCredentials() {
      this.updateStep(2, 'Validating user credentials...')

      const response = await api.auth.request.validateUserNoToken({
        username: this.form.email,
        password: this.form.password,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        MobilePhone: this.form.mobilePhone
      })

      await this.setProfileAuthInfo(response.data)
    },
    async attachUserToPatient(userId) {
      this.updateStep(3, 'Attaching user to patient...')

      const getPatientResp = await api.auth.request.getPatient({
        facilityId: this.linkInfo.facilityID,
        patientId: this.linkInfo.patientID
      })

      if (!getPatientResp?.data) {
        this.showError(
          'Patient lookup error',
          'Unable to retrieve patient information. Please try again.',
          3000
        )
        this.resetSavingState()
        return false
      }

      const patientInfo = getPatientResp.data
      const insertUserPatientRes = await api.auth.request.insertUserPatient({
        patientPortalUserID: userId,
        facilityKey: this.linkInfo.facilityKey,
        facilityId: this.linkInfo.facilityID,
        patientId: this.linkInfo.patientID,
        patientKey: this.linkInfo.patientKey,
        firstName: patientInfo.firstName,
        lastName: patientInfo.lastName,
        key: this.key
      })

      if (!insertUserPatientRes?.data) {
        this.showError(
          'Patient association error',
          'Unable to associate user with patient. Please try again.',
          3000
        )
        this.resetSavingState()
        return false
      }

      return true
    },
    async loadPatientProfile(userId) {
      this.updateStep(4, 'Loading patient profile...')

      const patientAssociated = await api.auth.request.getUserPatient(userId)
      this.setProfilePatientAssociated(patientAssociated.data)
      this.setProfileCurrentPatient(patientAssociated.data[0])
      this.$auth.completeAuth()

      // Redirect to home page since user is already authenticated
      this.isSaving = false
      this.$router.push({ path: '/' })
    },
    async processTaskRouting() {
      setTimeout(async () => {
        this.isSaving = false

        try {
          const taskRes = await api.task.request.getTask({
            facilityId: this.linkInfo.facilityID,
            patientId: this.linkInfo.patientID
          })

          this.task = taskRes.data.find(
            (el) => el.taskID === this.linkInfo.taskID
          )

          await this.loadFacilityInfo()

          if (!this.task || taskRes.data.taskID === 0) {
            this.handleNoTaskScenario()
            return
          }

          this.setTaskCode(this.task.taskType)
          this.handleTaskTypeRouting(taskRes.data)

          if (this.getTaskIsAccessOnly) {
            this.$router.push(this.getTaskIsAccessOnlyRoute)
          } else {
            this.setTaskCurrentTaskType('PatientInfo')
          }
        } catch (error) {
          console.error('Error processing task:', error)
          this.setTaskCurrentTaskType('PatientInfo')
        } finally {
          this.isSaving = false
        }
      }, 2000)
    },
    async loadFacilityInfo() {
      const facilityInfo = await api.auth.request.getFacilityInfo(
        this.linkInfo.facilityID
      )
      this.setFacilityInfo(facilityInfo)
      await this.setTaskOfficeName(facilityInfo.officeName)
    },
    handleNoTaskScenario() {
      this.hasAccount = false
      this.setTaskIsAccessOnly(true)
      this.setTaskCurrentTaskType('PatientInfo')
    },
    handleTaskTypeRouting(taskData) {
      const taskTypeHandlers = {
        NPH: () => {
          console.log('it is nph')
          this.setTaskCurrentTaskType('PatientInfo')
        },
        AANPH: () => {
          console.log('it is nph')
          this.setTaskCurrentTaskType('PatientInfo')
        },
        CH: () => {
          console.log('it is nph')
          this.setTaskCurrentTaskType('PatientInfo')
        },
        AACH: () => {
          console.log('it is nph')
          this.setTaskCurrentTaskType('PatientInfo')
        },
        STMT: () => {
          this.hasAccount = false
          this.setTaskIsAccessOnly(true)
          this.setTaskIsAccessOnly('/menu/statement')
          this.setBillingStatementTask(taskData)
          this.setTaskCurrentTaskType('Statement')
        },
        RESETPWD: () => {
          this.setTaskCurrentTaskType('ResetPassword')
        },
        INS: () => {
          this.$router.push({ path: '/account/login' })
        }
      }

      const handler = taskTypeHandlers[this.task.taskType]
      if (handler) {
        handler()
      } else {
        console.warn(
          'Unable to recognise task type ' + this.task.taskType
        )
        this.setTaskCurrentTaskType('PatientInfo')
      }
    },
    // Error handling methods
    showError(title, message, timer = 2000) {
      this.$swal({
        position: 'top',
        title,
        text: message,
        showConfirmButton: false,
        timerProgressBar: true,
        timer,
        icon: 'error'
      })
    },
    resetSavingState() {
      this.isSaving = false
      this.currentStep = 0
    },
    handleAccountCreationError(error) {
      console.error('Error during account creation:', error)
      this.showError(
        'Account creation error',
        'An error occurred during account creation. Please try again.',
        3000
      )
      this.resetSavingState()
    },
    async gotoLogin() {
      this.$auth.logout()
      this.$router.push({ path: '/account/login', query: { key: this.key } })
    }
  },
  async mounted() {
    // const getPatientResp = await api.auth.request.getPatient({
    //   facilityId: this.linkInfo.facilityID,
    //   patientId: this.linkInfo.patientID
    // })

    // this.patientInfo = getPatientResp.data

    setTimeout(() => {
      document.getElementById('em').focus()
    }, 500)
  }
}
</script>

<style scoped>
ul {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

li {
  margin-bottom: 8px;
  color: #525f7f;
  position: relative;
}

/* Checkmark & Strikethrough --------- */

.is_valid {
  color: rgba(136, 152, 170, 0.8);
  text-decoration: line-through;
  text-decoration-color: green;
}
.is_valid:before {
  width: 100%;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}

/* Loading Progress Styles */
.loading-progress {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e9ecef;
}

.progress-indicator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
}

.step:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 15px;
  left: 50%;
  width: 100%;
  height: 2px;
  background: #e9ecef;
  z-index: 1;
}

.step.completed:not(:last-child)::after {
  background: #28a745;
}

.step-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #6c757d;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.step.active .step-icon {
  background: #007bff;
  color: white;
}

.step.completed .step-icon {
  background: #28a745;
  color: white;
}

.step-label {
  font-size: 12px;
  color: #6c757d;
  text-align: center;
  margin-top: 5px;
  font-weight: 500;
}

.step.active .step-label {
  color: #007bff;
  font-weight: 600;
}

.step.completed .step-label {
  color: #28a745;
  font-weight: 600;
}

.current-step-message {
  text-align: center;
  color: #007bff;
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
}
</style>
